<!-- ============================================================
     CONTACT MESSAGES — contact_msgs
     id · full_name · email_id · mobile_no · msg_type
     subject · message · status · req_date · is_active
     ============================================================ -->
<div class="cm-page">

  @if (saveSuccess()) {
    <div class="cm-toast alert alert-success d-flex align-items-center gap-3 shadow">
      <i class="bi bi-check-circle-fill"></i>
      <span>{{ saveSuccess() }}</span>
    </div>
  }

  <!-- ── ADD / EDIT MODAL ── -->
  @if (showFormModal()) {
    <div class="cm-overlay" (click)="showFormModal.set(false)">
      <div class="cm-modal cm-modal-lg" (click)="$event.stopPropagation()">
        <div class="cm-modal-header">
          <div class="cmh-icon">
            <i class="bi {{ isEditing() ? 'bi-pencil-fill' : 'bi-envelope-plus-fill' }}"></i>
          </div>
          <div>
            <h5 class="cmh-title">{{ isEditing() ? 'Edit Contact Message' : 'Log Contact Message' }}</h5>
            <p class="cmh-sub">Fields match the contact_msgs record</p>
          </div>
          <button class="cmh-close" (click)="showFormModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>

        <div class="cm-modal-body">
          <form novalidate>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label fw-semibold">Full Name <span class="req">*</span></label>
                <input type="text" class="form-control" name="full_name"
                  [(ngModel)]="form.full_name" maxlength="80" placeholder="e.g. Meera Iyer"
                  [class.is-invalid]="submitted && errors.full_name">
                @if (submitted && errors.full_name) { <div class="invalid-feedback">{{ errors.full_name }}</div> }
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold">Email ID <span class="req">*</span></label>
                <input type="email" class="form-control" name="email_id"
                  [(ngModel)]="form.email_id" maxlength="100" placeholder="name@email.com"
                  [class.is-invalid]="submitted && errors.email_id">
                @if (submitted && errors.email_id) { <div class="invalid-feedback">{{ errors.email_id }}</div> }
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold">Mobile No <span class="req">*</span></label>
                <input type="tel" class="form-control" name="mobile_no"
                  [(ngModel)]="form.mobile_no" maxlength="10" placeholder="10-digit number"
                  [class.is-invalid]="submitted && errors.mobile_no">
                @if (submitted && errors.mobile_no) { <div class="invalid-feedback">{{ errors.mobile_no }}</div> }
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold">Message Type <span class="req">*</span></label>
                <select class="form-select" name="msg_type" [(ngModel)]="form.msg_type"
                  [class.is-invalid]="submitted && errors.msg_type">
                  @for (t of msgTypes; track t) { <option [value]="t">{{ t }}</option> }
                </select>
                @if (submitted && errors.msg_type) { <div class="invalid-feedback">{{ errors.msg_type }}</div> }
              </div>
              <div class="col-12">
                <label class="form-label fw-semibold">Subject <span class="req">*</span></label>
                <input type="text" class="form-control" name="subject"
                  [(ngModel)]="form.subject" maxlength="120" placeholder="Short subject line"
                  [class.is-invalid]="submitted && errors.subject">
                @if (submitted && errors.subject) { <div class="invalid-feedback">{{ errors.subject }}</div> }
              </div>
              <div class="col-12">
                <label class="form-label fw-semibold">Message <span class="req">*</span></label>
                <textarea class="form-control" name="message" rows="4"
                  [(ngModel)]="form.message" maxlength="1000"
                  placeholder="Full message from the contact…"
                  [class.is-invalid]="submitted && errors.message"></textarea>
                <div class="d-flex justify-content-between">
                  @if (submitted && errors.message) { <div class="invalid-feedback d-block">{{ errors.message }}</div> }
                  <small class="text-muted ms-auto">{{ form.message.length }}/1000</small>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold">Status <span class="req">*</span></label>
                <select class="form-select" name="status" [(ngModel)]="form.status"
                  [class.is-invalid]="submitted && errors.status">
                  @for (s of statusOptions; track s) { <option [value]="s">{{ s }}</option> }
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold d-block">Active</label>
                <label class="toggle-switch mt-1">
                  <input type="checkbox" name="is_active" [(ngModel)]="form.is_active">
                  <span class="ts-track"><span class="ts-thumb"></span></span>
                  <span class="ts-label" [class.active]="form.is_active">{{ form.is_active ? 'Active' : 'Inactive' }}</span>
                </label>
              </div>
            </div>
          </form>
        </div>

        <div class="cm-modal-footer">
          <button class="btn btn-outline-secondary px-4" (click)="showFormModal.set(false)">Cancel</button>
          <button class="btn btn-primary-erp px-5" (click)="save()">
            <i class="bi {{ isEditing() ? 'bi-check-circle-fill' : 'bi-plus-circle-fill' }} me-2"></i>
            {{ isEditing() ? 'Update Message' : 'Save Message' }}
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ── VIEW MODAL ── -->
  @if (showViewModal() && viewTarget(); as m) {
    <div class="cm-overlay" (click)="showViewModal.set(false)">
      <div class="cm-modal cm-modal-lg" (click)="$event.stopPropagation()">
        <div class="cm-modal-header">
          <div class="cm-avatar">{{ initials(m.full_name) }}</div>
          <div class="flex-grow-1">
            <h5 class="cmh-title">{{ m.full_name }}</h5>
            <p class="cmh-sub mb-0">#{{ m.id }} · {{ formatDateTime(m.req_date) }}</p>
          </div>
          <span class="status-pill {{ statusClass(m.status) }}">{{ m.status }}</span>
          <button class="cmh-close" (click)="showViewModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="cm-modal-body">
          <div class="view-meta">
            <div><span>Email</span><a [href]="'mailto:' + m.email_id">{{ m.email_id }}</a></div>
            <div><span>Mobile</span><a [href]="'tel:' + m.mobile_no">{{ m.mobile_no }}</a></div>
            <div><span>Type</span><span class="type-badge {{ typeClass(m.msg_type) }}">{{ m.msg_type }}</span></div>
            <div><span>Active</span>{{ m.is_active ? 'Yes' : 'No' }}</div>
          </div>
          <div class="view-subject">{{ m.subject }}</div>
          <p class="view-message">{{ m.message }}</p>
          <div class="view-status-row">
            <label class="form-label small fw-semibold text-muted mb-1">Update status</label>
            <div class="status-filter-group">
              @for (s of statusOptions; track s) {
                <button class="sfg-btn" [class.active]="m.status === s" (click)="setStatus(m, s)">{{ s }}</button>
              }
            </div>
          </div>
        </div>
        <div class="cm-modal-footer">
          <button class="btn btn-outline-danger me-auto" (click)="confirmDelete(m)"><i class="bi bi-trash3 me-1"></i>Delete</button>
          <button class="btn btn-outline-secondary" (click)="showViewModal.set(false)">Close</button>
          <button class="btn btn-primary-erp" (click)="openEdit(m)"><i class="bi bi-pencil-fill me-1"></i>Edit</button>
        </div>
      </div>
    </div>
  }

  <!-- ── DELETE MODAL ── -->
  @if (showDeleteModal()) {
    <div class="cm-overlay" (click)="showDeleteModal.set(false)">
      <div class="cm-modal cm-modal-sm" (click)="$event.stopPropagation()">
        <div class="cm-modal-body text-center py-4">
          <div class="del-icon"><i class="bi bi-trash3-fill"></i></div>
          <h5 class="mt-3 mb-1">Delete Message?</h5>
          <p class="text-muted small mb-0">
            Remove the message from <strong>{{ deleteTarget()?.full_name }}</strong>
            about <em>{{ deleteTarget()?.subject }}</em>. This cannot be undone.
          </p>
        </div>
        <div class="cm-modal-footer">
          <button class="btn btn-outline-secondary px-4" (click)="showDeleteModal.set(false)">Cancel</button>
          <button class="btn btn-danger px-4" (click)="executeDelete()"><i class="bi bi-trash3 me-2"></i>Delete</button>
        </div>
      </div>
    </div>
  }

  <!-- ===================== PAGE HEADER ===================== -->
  <div class="page-header mb-4">
    <div>
      <h1 class="page-title">
        <i class="bi bi-envelope-paper-fill me-2 text-primary" style="font-size:1.1rem;"></i>
        Contact Messages
      </h1>
      <p class="page-subtitle">
        Inbox for contact_msgs · {{ stats().total }} active · {{ stats().new }} new
      </p>
    </div>
    <!-- <button class="btn btn-primary-erp" (click)="openAdd()">
      <i class="bi bi-plus-circle-fill me-2"></i>Log Message
    </button> -->
  </div>

  <!-- ===================== STAT CARDS ===================== -->
  <div class="row g-3 mb-4">
    <div class="col-6 col-md">
      <div class="cm-stat">
        <div class="cms-icon bg-primary-g"><i class="bi bi-inbox-fill"></i></div>
        <div class="cms-val">{{ stats().total }}</div>
        <div class="cms-label">Active</div>
      </div>
    </div>
    <div class="col-6 col-md">
      <div class="cm-stat">
        <div class="cms-icon bg-info-g"><i class="bi bi-envelope-exclamation-fill"></i></div>
        <div class="cms-val text-info">{{ stats().new }}</div>
        <div class="cms-label">New</div>
      </div>
    </div>
    <div class="col-6 col-md">
      <div class="cm-stat">
        <div class="cms-icon bg-warning-g"><i class="bi bi-hourglass-split"></i></div>
        <div class="cms-val text-warning">{{ stats().progress }}</div>
        <div class="cms-label">In Progress</div>
      </div>
    </div>
    <div class="col-6 col-md">
      <div class="cm-stat">
        <div class="cms-icon bg-teal-g"><i class="bi bi-reply-fill"></i></div>
        <div class="cms-val" style="color:#0d9488">{{ stats().replied }}</div>
        <div class="cms-label">Replied</div>
      </div>
    </div>
    <div class="col-6 col-md">
      <div class="cm-stat">
        <div class="cms-icon bg-gray-g"><i class="bi bi-archive-fill"></i></div>
        <div class="cms-val text-muted">{{ stats().closed }}</div>
        <div class="cms-label">Closed</div>
      </div>
    </div>
  </div>

  <!-- ===================== FILTERS ===================== -->
  <div class="cm-card mb-3">
    <div class="cm-card-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label small fw-semibold text-muted">Search</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted" style="font-size:.85rem;"></i></span>
            <input type="text" class="form-control border-start-0" name="cmSearch"
              placeholder="Name, email, mobile, subject…"
              [ngModel]="searchQuery()"
              (ngModelChange)="onSearchChange($event)">
            @if (searchQuery()) {
              <button class="btn btn-outline-secondary" (click)="searchQuery.set(''); onFilterChange()">
                <i class="bi bi-x"></i>
              </button>
            }
          </div>
        </div>
        <div class="col-md-2 col-sm-6">
          <label class="form-label small fw-semibold text-muted">Type</label>
          <select class="form-select" name="cmType" [ngModel]="filterType()"
            (ngModelChange)="setTypeFilter($event)">
            <option [ngValue]="'all'">All types</option>
            @for (t of msgTypes; track t) { <option [ngValue]="t">{{ t }}</option> }
          </select>
        </div>
        <div class="col-md-2 col-sm-6">
          <label class="form-label small fw-semibold text-muted">Status</label>
          <select class="form-select" name="cmStatus" [ngModel]="filterStatus()"
            (ngModelChange)="setStatusFilter($event)">
            <option [ngValue]="'all'">All statuses</option>
            @for (s of statusOptions; track s) { <option [ngValue]="s">{{ s }}</option> }
          </select>
        </div>
        <div class="col-auto">
          <label class="form-label small fw-semibold text-muted">Rows</label>
          <select class="form-select" name="cmPageSize" style="width:75px;"
            [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)">
            <option [ngValue]="5">5</option>
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
          </select>
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-secondary" (click)="resetFilters()">
            <i class="bi bi-arrow-counterclockwise me-1"></i>Reset
          </button>
        </div>
      </div>

      <div class="d-flex align-items-center flex-wrap gap-2 mt-3">
        <div class="status-filter-group">
          @for (opt of [{v:'all',l:'All'},{v:'active',l:'Active'},{v:'inactive',l:'Inactive'}]; track opt.v) {
            <button class="sfg-btn"
              [class.active]="filterActive() === opt.v"
              (click)="filterActive.set($any(opt.v)); onFilterChange()">{{ opt.l }}</button>
          }
        </div>
        <small class="text-muted ms-auto">
          Showing <strong>{{ paged().length }}</strong> of <strong>{{ filtered().length }}</strong>
          @if (filtered().length !== messages().length) { <span class="badge bg-primary-subtle text-primary ms-1">filtered</span> }
        </small>
      </div>
    </div>
  </div>

  <!-- ===================== TABLE ===================== -->
  <div class="cm-card">
    <div class="cm-card-body p-0">
      @if (paged().length === 0) {
        <div class="empty-state">
          <i class="bi bi-envelope-x"></i>
          <p>No contact messages found</p>
          @if (searchQuery() || filterStatus() !== 'all' || filterType() !== 'all' || filterActive() !== 'all') {
            <button class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">
              <i class="bi bi-arrow-counterclockwise me-1"></i>Clear filters
            </button>
          } @else {
            <button class="btn btn-primary-erp btn-sm" (click)="openAdd()">
              <i class="bi bi-plus-circle me-1"></i>Log first message
            </button>
          }
        </div>
      } @else {
        <div class="table-responsive">
          <table class="cm-table">
            <thead>
              <tr>
                <th class="sortable" (click)="sortBy('id')">ID <i class="bi {{ sortIcon('id') }} ms-1"></i></th>
                <th class="sortable" (click)="sortBy('full_name')">Name <i class="bi {{ sortIcon('full_name') }} ms-1"></i></th>
                <!-- <th class="d-none d-lg-table-cell sortable" (click)="sortBy('email_id')">Email <i class="bi {{ sortIcon('email_id') }} ms-1"></i></th> -->
                <!-- <th class="d-none d-xl-table-cell">Mobile</th> -->
                <!-- <th class="sortable" (click)="sortBy('msg_type')">Type <i class="bi {{ sortIcon('msg_type') }} ms-1"></i></th> -->
                <th class="sortable" (click)="sortBy('subject')">Subject <i class="bi {{ sortIcon('subject') }} ms-1"></i></th>
                <th class="sortable text-center" (click)="sortBy('status')">Status <i class="bi {{ sortIcon('status') }} ms-1"></i></th>
                <th class="d-none d-lg-table-cell sortable" (click)="sortBy('req_date')">Requested <i class="bi {{ sortIcon('req_date') }} ms-1"></i></th>
                <th class="text-center">Active</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (m of paged(); track m.id) {
                <tr [class.row-inactive]="!m.is_active" [class.row-new]="m.status === 'New'" (click)="openView(m)">
                  <td class="td-id">{{ m.id }}</td>
                  <td>
                    <div class="name-cell">
                      <span class="mini-av">{{ initials(m.full_name) }}</span>
                      <div>
                        <span class="fw-semibold">{{ m.full_name }}</span><br>
                        <small>{{ m.email_id }}<br>(M): {{ m.mobile_no }}</small>
                      </div>
                    </div>
                  </td>
                  <!-- <td class="d-none d-lg-table-cell text-muted small">{{ m.email_id }}</td> -->
                  <!-- <td class="d-none d-xl-table-cell text-muted small">{{ m.mobile_no }}</td> -->
                  <!-- <td><span class="type-badge {{ typeClass(m.msg_type) }}">{{ m.msg_type }}</span></td> -->
                  <td>
                    <div class="subj">{{ truncate(m.subject, 42) }}</div>
                    <div class="subj-preview d-none d-md-block">{{ truncate(m.message, 56) }}</div>
                  </td>
                  <td class="text-center">
                    <span class="type-badge {{ typeClass(m.msg_type) }}">{{ m.msg_type }}</span><br>
                    <span class="status-pill {{ statusClass(m.status) }}">{{ m.status }}</span>
                  </td>
                  <td class="d-none d-lg-table-cell text-muted small">{{ formatDateTime(m.req_date)|date }}</td>
                  <td class="text-center" (click)="$event.stopPropagation()">
                    <button class="status-toggle-btn" [class.st-active]="m.is_active" [class.st-inactive]="!m.is_active"
                      (click)="toggleActive(m)" [title]="m.is_active ? 'Deactivate' : 'Activate'">
                      <i class="bi" [class.bi-toggle-on]="m.is_active" [class.bi-toggle-off]="!m.is_active"></i>
                    </button>
                  </td>
                  <td (click)="$event.stopPropagation()">
                    <div class="row-actions">
                      <button class="ra-btn view" (click)="openView(m)" title="View"><i class="bi bi-eye-fill"></i></button>
                      <button class="ra-btn edit" (click)="openEdit(m)" title="Edit"><i class="bi bi-pencil-fill"></i></button>
                      <button class="ra-btn delete" (click)="confirmDelete(m)" title="Delete"><i class="bi bi-trash3-fill"></i></button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (totalPages() > 1) {
          <div class="pag-row">
            <div class="pag-info">Page {{ currentPage() }} of {{ totalPages() }} · {{ filtered().length }} records</div>
            <div class="pag-btns">
              <button class="pb" [disabled]="currentPage()===1" (click)="goToPage(1)"><i class="bi bi-chevron-double-left"></i></button>
              <button class="pb" [disabled]="currentPage()===1" (click)="goToPage(currentPage()-1)"><i class="bi bi-chevron-left"></i></button>
              @for (p of pageNumbers(); track p) {
                <button class="pb" [class.active]="p===currentPage()" (click)="goToPage(p)">{{ p }}</button>
              }
              <button class="pb" [disabled]="currentPage()===totalPages()" (click)="goToPage(currentPage()+1)"><i class="bi bi-chevron-right"></i></button>
              <button class="pb" [disabled]="currentPage()===totalPages()" (click)="goToPage(totalPages())"><i class="bi bi-chevron-double-right"></i></button>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
